import React from 'react'
import Styles from "./FJCloudSyncButton.module.less";
import FJLocalStore from "../../../../store/FJLocalStore";
import FJPureLoading from "../../../../common/component/FJLoading/FJPureLoading";

function FJCloudSyncButton() {
  return (
    <div className={Styles.cloud_sync}>
      <span>{FJLocalStore._('cloud-sync')}</span>
      <FJPureLoading/>
    </div>
  );
}

export default FJCloudSyncButton;